module.exports = __webpack_public_path__ + "static/media/102279743_1605782456251897_180731914993447595_n.6c740771.jpg";